import StoreBuildService from './service';

export * from './reqres';

export default StoreBuildService;
